export enum BoosterStatus {
  Pending = 'Pending',
  Verified = 'Verified',
  Unverified = 'Unverified',
  Paused = 'Paused',
}
